import Modal from 'components/modal/modal'
import Footer from 'components/modal/footer'

export { Footer }

export default Modal
